import React from "react";
import frontendicon from "../assets/images/frontendicon.svg";

const FrontendSkill = () => {
  return (
    <div className="bg-white shadow-sm py-4 px-5 position-relative">
      <h4 className="text-center mb-3 mt-5">Frontend</h4>
      <div className="skills-icon-holder position-absolute d-inline-block rounded-circle text-center bg-light">
        <img className="text-center" src={frontendicon} alt="Frontend" />
      </div>
      <ul>
        <li>React</li>
        <li>Javascript</li>
        <li>Node.js</li>
        <li>HTML/CSS</li>
      </ul>
    </div>
  );
};

export default FrontendSkill;
